import { gameData } from "../GameManager";
import { Particle, ParticleBreed } from "../../engine/anims/Particle";
import { SparseMap } from "../../lib/sparseMap";

class ParticleSystem {
  id = 0;

  startOfTurn: Particle<any>[] = [];
  endOfTurn: Particle<any>[] = [];

  constructor(private getData: () => SparseMap<number, Particle<any>>) {}
  createParticle<T>(
    breed: ParticleBreed<T>,
    x: number,
    y: number,
    options?: T
  ) {
    const particles = this.getData();

    const assigned = this.id;
    const p = new Particle<T>(breed, assigned, x, y, options);
    particles.add(assigned, p);
    this.id += 1;
    p.status.then(() => particles.remove(assigned));
    return p;
  }

  async runThenDestroy<T>(
    breed: ParticleBreed<T>,
    x: number,
    y: number,
    options?: T
  ) {
    const p = this.createParticle(breed, x, y, options);
    await p.status;
  }

  makeUntilEndOfTurn<T>(
    breed: ParticleBreed<T>,
    x: number,
    y: number,
    options?: T
  ) {
    const p = this.createParticle(breed, x, y, options);
    this.endOfTurn.push(p);
    return p;
  }

  makeUntilStartOfTurn<T>(
    breed: ParticleBreed<T>,
    x: number,
    y: number,
    options?: T
  ) {
    const p = this.createParticle(breed, x, y, options);
    this.startOfTurn.push(p);
    return p;
  }

  clearStartOfTurn() {
    let p: Particle<any> | undefined;
    // eslint-disable-next-line no-cond-assign
    while ((p = this.startOfTurn.pop())) {
      p.finish();
    }
  }

  clearEndOfTurn() {
    let p: Particle<any> | undefined;
    // eslint-disable-next-line no-cond-assign
    while ((p = this.endOfTurn.pop())) {
      p.finish();
    }
  }
}

export const ParticleManager = new ParticleSystem(() => gameData.particles);
export const GibManager = new ParticleSystem(() => gameData.gibs);
